import React from 'react';

export default class NotFound extends React.Component {
  render() {
    return (
      <div data-testid="page-not-found">Page not found</div>
    );
  }
}
